module.exports = __webpack_public_path__ + "static/img/verCodeImg2.11c331f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/verCodeImg2.png
// module id = tOD2
// module chunks = 7